module.exports = __webpack_public_path__ + "img/911adb9.png";